import React from 'react'
import Layout from 'features/layout/components/Layout'
import User from '../components/User'

const UserPage = (props) => {
  return (
    <Layout>
      <User />
    </Layout>
  )
}

export default UserPage
